import axios from 'axios';
import Api from '../api/ApiUrl';

const API_URL = `${Api}/api/v1`;

const config = {
  headers: {
      // Authorization: `Bearer ${Cookies.get('token')}`,
      role: 'admin'
  },
};
const AuctionService = {
  API_URL,
  fetchEndedAuctions: async ({ page, limit }) => {
    const response = await axios.get(`${API_URL}/admin/endedauction`, { params: { page, limit } },config);
    return response.data;
  },
  fetchAuctionDetails: async (id) => {
    const response = await axios.get(`${API_URL}/admin/endedauction/${id}`,config);
    return response.data;
  },
  fetchWinnersOrLosers: async (itemId, status) => {
    const response = await axios.get(`${API_URL}/admin/endedauction/details/${itemId}/${status}`,config);
    console.log(status,response)
    return response.data;
  },
  performAdminAction: async (winnerId, action) => {
    const response = await axios.post(`${API_URL}/admin/endedauction/admin-action`, { winnerId, action },config);
    return response.data;
  }
};

export default AuctionService;
